import React, { useState } from "react";
import {
  REQ_TYPE_ACCESS_REQUEST,
  REQ_TYPE_NEW_REQUEST,
} from "../../../../../constants/Constants";
import { Modal, Button, Form } from "react-bootstrap";
import "./style.css";

const RequestTypeSelection = ({ typeChangeHandler }) => {
  const [requestType, setRequestType] = useState(null);

  const checkBoxChangeHandler = (e) => {
    setRequestType(e.target.id);
  };

  return (
    <Form>
      <Modal.Body className="selectNewAccessType_modalBody">
        <Form.Row style={{ marginBottom: 20 }}>
          <p>
            This Company/Legal/Billing Name and/or Duns # already exists within
            our vendor onboarding application.
          </p>
        </Form.Row>
        <p style={{ fontStyle: "italic" }}>
          Please select from one of the following two options:
        </p>
        <Form.Row style={{ marginBottom: 15 }}>
          <Form.Check
            type="checkbox"
            id={REQ_TYPE_ACCESS_REQUEST}
            label="I am an employee of this company and would like to request access to my company's application in order to assist in the onboarding process(i.e. upload documents, provide additional information, etc.)."
            checked={requestType === REQ_TYPE_ACCESS_REQUEST}
            onChange={checkBoxChangeHandler}
          />
        </Form.Row>
        <Form.Row>
          <Form.Check
            type="checkbox"
            id={REQ_TYPE_NEW_REQUEST}
            label="I am an employee of this company and would like to initiate the onboarding process for a new product type or fulfillment type that I do not currently offer with Macy's Inc."
            checked={requestType === REQ_TYPE_NEW_REQUEST}
            onChange={checkBoxChangeHandler}
          />
        </Form.Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{ float: "right" }}
          className="button-primary-md"
          type="submit"
          disabled={!requestType}
          onClick={() => typeChangeHandler(requestType)}
        >
          CONTINUE
        </Button>
      </Modal.Footer>
    </Form>
  );
};
export default RequestTypeSelection;
